import { SET_REQUEST_FORM } from './requestFormTypes';

const initialState = {
    supportedState: '',
    onBehalfOf:'',
    customerRelation:'',
    brand:'',
    selectedFlow: '',
}

const requestFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REQUEST_FORM:
            return { ...state, step: action.payload };
        default:
            return state;
    }
}

export default requestFormReducer;